import * as S from './styled'

export function ToastContainer() {
  return <S.Container />
}
